import { useSyncExternalStore } from "react";

// El evento beforeinstallprompt se dispara una sola vez, así que lo guardamos
// a nivel de módulo para que cualquier componente montado después lo vea.
let deferredPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => listener());
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

async function installApp() {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  await deferredPrompt.userChoice;
  deferredPrompt = null;
  notify();
}

export function usePWAInstall() {
  const isInstallable = useSyncExternalStore(subscribe, () => deferredPrompt !== null);
  return { isInstallable, installApp };
}
